import Point from "../../../../../src/entities/Point";
import { Coord } from "../../../../../src/types/Interface";
import { QuestionType, ShapeColor } from "../types/Enum";


export default class PivotPoint extends Point {
  constructor(color:number = ShapeColor.black){
    super({ x: -1, y: -1 }, color, 15, false)
  }

  drawPoint(pointCoord: Coord, origin: Coord, qType: QuestionType) {
    this.clear();

    if (
      origin 
        && origin.x == this.x 
        && origin.y == this.y
    ) {
      return
    }
    this.draw(pointCoord);
  }
}